import React, { Component } from 'react'
import { 
    Icon,
    Menu,
    Button,
    Modal
} from 'semantic-ui-react'

export default class NewTopMenu extends Component {
    static CANVA_BASE = "https://delivery.hommati.com";

    constructor(props) {
        super(props);
        this.state={'MenuActiveItem': 'show_me_photos', canvaConnected: false, disconnectModalOpen: false};
        this.btnTapped = this
        .btnTapped
        .bind(this);
    }
    //state = {}

    componentDidMount() {
        fetch(`${NewTopMenu.CANVA_BASE}/api/oauth/status`, { credentials: 'include' })
            .then(res => res.json())
            .then(data => this.setState({ canvaConnected: !!data.authenticated }))
            .catch(() => {});
    }

    stickyStyle = () => {
        return(
            {
                'position': 'sticky',
                zIndex: '1000'
            }
        )
    }

    btnTapped(e, { name }) {
        this.setState({ MenuActiveItem: name })
        document.getElementById(name).scrollIntoView()
    }
    
    handleItemClick = (e, { name }) => this.setState({ activeItem: "photos" })

    handleDisconnect = () => {
        fetch(`${NewTopMenu.CANVA_BASE}/api/oauth/revoke`, { method: 'POST', credentials: 'include' })
            .catch(() => {})
            .finally(() => {
                this.setState({ canvaConnected: false, disconnectModalOpen: false });
            });
    }
    
    render() {
        const { activeItem } = this.state

        return (
            <>
            <Menu
                attached='bottom' 
                fluid={true}
                stackable={true}
                style={this.stickyStyle()}
                widths={8}
            >
                <Menu.Item
                    name='scroll_to_top'
                    active={activeItem === 'scroll_to_top'}
                    onClick={this.btnTapped}
                >
                        <Icon name='home' />Top of Page
                </Menu.Item>
                <Menu.Item
                    name='show_me_photos'
                    active={activeItem === 'show_me_photos'}
                    onClick={this.btnTapped}
                >

                        <Icon name='camera' />
                        Photos ({this.props.total_photos})
                </Menu.Item>
                <Menu.Item
                    name='show_me_floorplans'
                    active={activeItem === 'show_me_floorplans'}
                    onClick={this.btnTapped}
                >
                        <Icon name='rss' />
                        Floor Plans ({this.props.total_floorplans})
                </Menu.Item>
                <Menu.Item
                    name='show_me_brochures'
                    active={activeItem === 'show_me_brochures'}
                    onClick={this.btnTapped}
                >
                        <Icon name='file pdf outline' />
                        Brochures ({this.props.total_brochures})
                </Menu.Item>
                <Menu.Item
                    name='show_me_videos'
                    active={activeItem === 'show_me_videos'}
                    onClick={this.btnTapped}
                >
                        <Icon name='file video outline' />
                        Videos ({this.props.total_videos})
                </Menu.Item>
                <Menu.Item
                    name='show_me_tours'
                    active={activeItem === 'show_me_tours'}
                    onClick={this.btnTapped}
                >
                        <Icon name='globe' />
                        3D Tours ({this.props.total_3dtours})
                </Menu.Item>
                <Menu.Item
                    name='show_me_links'
                    active={activeItem === 'show_me_links'}
                    onClick={this.btnTapped}
                >
                        <Icon name='linkify' />
                        Links
                </Menu.Item>
                <Menu.Item>
                    <Button
                        style={this.state.canvaConnected ? { backgroundColor: 'rgb(153, 43, 255)', color: '#fff' } : { backgroundColor: '#db2828', color: '#fff' }}
                        onClick={this.state.canvaConnected
                            ? () => this.setState({ disconnectModalOpen: true })
                            : () => { const previewReturnTo = new URL(window.location.pathname + window.location.search, NewTopMenu.CANVA_BASE); if (window.location.hostname === 'delivery.hommati.com') { previewReturnTo.searchParams.set('redirect_after', window.location.href); } window.location.href = `${NewTopMenu.CANVA_BASE}/api/oauth/authorize?return_to=${encodeURIComponent(previewReturnTo.href)}`; }}
                    >
                        {this.state.canvaConnected ? 'Canva Status: Connected' : 'Connect to Canva'}
                    </Button>
                </Menu.Item>
            </Menu>

            <Modal size='tiny' open={this.state.disconnectModalOpen} onClose={() => this.setState({ disconnectModalOpen: false })}>
                <Modal.Header>Disconnect from Canva</Modal.Header>
                <Modal.Content>
                    <p>Are you sure you want to disconnect your Canva account?</p>
                </Modal.Content>
                <Modal.Actions>
                    <Button onClick={() => this.setState({ disconnectModalOpen: false })}>Cancel</Button>
                    <Button negative onClick={this.handleDisconnect}>Yes, Disconnect</Button>
                </Modal.Actions>
            </Modal>
            </>
        )
    }
}